import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/index.tsx';
import { legacyGinIssueMoveRoute } from '@atlassian/jira-router-routes-legacy-gin-issue-move-routes/src/index.tsx';

export const legacyGinIssueMoveRouteEntry = createEntry(legacyGinIssueMoveRoute, () => ({
	layout: globalLayout,
}));
